// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/mutation-insurance-payment-account.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateInvoice(
  $insurance_company_id: numeric!
  $parent_organization_id: numeric!
) {
  insert_vaxiom_insurance_payment_accounts_one(
    object: {
      insurance_company_id: $insurance_company_id
      organization_id: $parent_organization_id
      payment_account: {
        data: { account_type: InsurancePaymentAccount, temp: false }
      }
    }
  ) {
    id
    payment_account {
      id
    }
  }
}

`